import { render, staticRenderFns } from "./labelSkill.vue?vue&type=template&id=5d5d5e39&scoped=true"
import script from "./labelSkill.vue?vue&type=script&lang=js"
export * from "./labelSkill.vue?vue&type=script&lang=js"
import style0 from "./labelSkill.vue?vue&type=style&index=0&id=5d5d5e39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d5e39",
  null
  
)

export default component.exports